import { render, staticRenderFns } from "./SignUpVerificationContainer.vue?vue&type=template&id=a68b8126&scoped=true"
import script from "./SignUpVerificationContainer.vue?vue&type=script&lang=js"
export * from "./SignUpVerificationContainer.vue?vue&type=script&lang=js"
import style0 from "./SignUpVerificationContainer.vue?vue&type=style&index=0&id=a68b8126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68b8126",
  null
  
)

export default component.exports